import React from 'react';
import PropTypes from 'prop-types';
import { IconLaptop, IconTablet, IconMobile } from 'shared/components';

const DeviceIcon = ({ device }) => {
  if (device === 'desktop') {
    return <IconLaptop />;
  }
  if (device === 'tablet') {
    return <IconTablet />;
  }
  if (device === 'mobile') {
    return <IconMobile />;
  }
  return '-';
};

DeviceIcon.propTypes = {
  device: PropTypes.string,
};

DeviceIcon.defaultProps = {
  device: null,
};

export default DeviceIcon;
